var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"hamburger",class:{ 'hamburger--is-active': _vm.isActive },on:{"click":_vm.handleClick}},[_c('span',{staticClass:"hamburger__icon"})])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05e037cb","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/containers/Navigation/Hamburger.vue
// module id = null
// module chunks = 